import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import {footerLogoSvg} from 'constants/svg';

export default function () {
    return(
        <footer className="main-footer">
            <div className="container-fluid">
                <div className="row justify-content-center h-100">
                    <div className="col-md-5 order-md-1">
                        <ul className="foot-list">
                            <li>
                                <Link to="/terms-of-service">
                                    Terms of Service
                                </Link>
                            </li>
                            <li>
                                <Link to="/privacy-policy">
                                    Privacy Policy
                                </Link>
                            </li>
                            <li>
                                <Link to="/cookies-policy">
                                    Cookies Policy
                                </Link>
                            </li>
                        </ul>
                    </div>
                    <div className="col-md-7">
                        <div className="copyright">
                            <Link className="logo" to="/home">
                                {footerLogoSvg}
                            </Link>
                             {`© Prescription Revision ${moment().format('YYYY')}. All rights reserved.`}
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}



// WEBPACK FOOTER //
// ./src/modules/core/containers/Footer.jsx